import { render, staticRenderFns } from "./androidPwaInstall.vue?vue&type=template&id=4a3b0dd4&scoped=true&"
import script from "./androidPwaInstall.vue?vue&type=script&lang=js&"
export * from "./androidPwaInstall.vue?vue&type=script&lang=js&"
import style0 from "./androidPwaInstall.vue?vue&type=style&index=0&id=4a3b0dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b0dd4",
  null
  
)

export default component.exports